import React from 'react';
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
} from 'recharts';

const COLORS = {
  journalier: '#3b82f6',
  mensuel: '#8b5cf6',
  annuel: '#10b981',
};

const CustomTooltip = ({ active, payload, label, unitLabel }) => {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-lg px-4 py-2">
      <p className="text-sm text-gray-500">{label}</p>
      <p className="text-base font-semibold text-gray-800">
        {payload[0].value} {unitLabel}
      </p>
    </div>
  );
};

const VolumeChart = ({ data, colorKey = 'journalier', unitLabel }) => {
  const color = COLORS[colorKey] || COLORS.journalier;
  const gradientId = `gradient-${colorKey}`;

  return (
    <ResponsiveContainer width="100%" height={320}>
      <AreaChart data={data} margin={{ top: 20, right: 20, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={color} stopOpacity={0.45} />
            <stop offset="95%" stopColor={color} stopOpacity={0.02} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eef0f2" />
        <XAxis dataKey="name" tick={{ fill: '#6b7280', fontSize: 12 }} axisLine={false} tickLine={false} />
        <YAxis tick={{ fill: '#6b7280', fontSize: 12 }} axisLine={false} tickLine={false} width={45} />
        <Tooltip content={<CustomTooltip unitLabel={unitLabel} />} />
        <Area
          type="monotone"
          dataKey="Volume"
          stroke={color}
          strokeWidth={2.5}
          fill={`url(#${gradientId})`}
          activeDot={{ r: 5, strokeWidth: 0 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default VolumeChart;